export default __webpack_public_path__ + "static/media/chaeyoung2.a765855f.jpg";